import { render, staticRenderFns } from "./SocialMediaShareModal.vue?vue&type=template&id=6037690a&scoped=true"
import script from "./SocialMediaShareModal.vue?vue&type=script&lang=js"
export * from "./SocialMediaShareModal.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaShareModal.vue?vue&type=style&index=0&id=6037690a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6037690a",
  null
  
)

export default component.exports